// extracted by mini-css-extract-plugin
export var _187 = "RecruitCultureBgBtm-module--_187--3LFMz";
export var bg04_b = "RecruitCultureBgBtm-module--bg04_b--3z25q";